export enum ESourceTagRelation {
  "E_MAGAZINE" = "E_MAGAZINE",
  "INVENTORY" = "INVENTORY",
}

export type TTagOutputModel = {
  id: string;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: null;
  name: string;
  source: ESourceTagRelation;
  searchValue: string;
};

export type ICreateTagOutputModel = Pick<TTagOutputModel, "name" | "source">;

export type IUpdateTagOutputModel = Pick<TTagOutputModel, "name" | "source">;

export type IDeleteTagInputputModel = Pick<TTagOutputModel, "source">;
